
export const _mergeCoutingObjects = (obj1, obj2) => {
    const merged = { ...obj1 };
  
    for (const key in obj2) {
      if (merged.hasOwnProperty(key)) {
        merged[key] += obj2[key];
      } else {
        merged[key] = obj2[key];
      }
    }
    return merged;
  };
  
  export const _calculateTotalAmountAndQuantity = (ancillary) => {
    let totalAmount = 0;
    let totalQuantity = 0;
    ancillary.selectedPassengers.forEach((passenger) => {
      totalAmount += ancillary.ancInfo.amount * passenger.quantity;
      totalQuantity += passenger.quantity;
    });
    return { totalAmount, totalQuantity };
  };
  
  export const _createVariantString = (data) => {
    let result = "";
  
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        if (
          data[key] !== 0 &&
          (!Array.isArray(data[key]) || data[key].some((val) => val !== 0))
        ) {
          result += `${key}/`;
  
          if (Array.isArray(data[key])) {
            for (const value of data[key]) {
              if (value !== 0) {
                result += `${value}|`;
              }
            }
          } else {
            result += `${data[key]}|`;
          }
        }
      }
    }
  
    result = result.slice(0, -1);
    return result;
  };
  
  export const _createVariantSeatsString = (data) => {
    let result = "";
  
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        result += `${key}/`;
  
        for (const value of data[key]) {
          result += `${value}|`;
        }
      }
    }
    result = result.slice(0, -1);
    return result;
  };
  
